/**
 * API エンドポイント設定
 * maintenanceと同様にwindow.locationベースで動的に判定
 */

/**
 * APIのベースURLを取得
 * 1. 環境変数が設定されていればそれを使用
 * 2. なければ window.location.origin を使用
 */
export function getApiEndpoint(): string {
  // 環境変数から取得（開発環境や特定環境で固定URLが必要な場合）
  const envUrl = import.meta.env.VITE_EXPERIENCE_API_URL as string;

  if (envUrl) {
    return envUrl;
  }

  // 本番環境: window.location.origin を使用
  return window.location.origin;
}

/**
 * 必要に応じてサブドメイン置き換えロジックを追加
 * 例: experience. → api. のような置き換えが必要な場合
 */
export function getApiEndpointWithSubdomainReplace(): string {
  const envUrl = import.meta.env.VITE_EXPERIENCE_API_URL as string;

  if (envUrl) {
    return envUrl;
  }

  // サブドメイン置き換えが必要な場合はこちらを使用
  // 例: https://experienceform.dds.click → https://experience.dds.click
  const origin = window.location.origin;
  return origin.replace(/:\/{2}experienceform(-tokyo|-osaka)?\./, '://experience$1.');
}
